module.exports = __webpack_public_path__ + "e1d2356c.webp";